// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"0b3c59f8","344":"be26328b","453":"687ec5ba","789":"b7abf89a","872":"61fbc517"}[chunkId] + ".chunk.js";
};